import * as React from 'react';
import style from './index.less';
import cx from 'classnames';
import Link from '../link';
import * as commonRegex from '../../utils/common-regex';
import { message } from 'antd';
import lockAsync from '@src/utils/lock-async';
import { getLocales } from '@src/global-locales/get-page-locales-data';

import { noop } from '@src/utils/common-util';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
/**
 * 使用举例:
 * <SmsCodeInput
 *  phone={store.phoneInputStore.value}
 *  buttonText={'发送验证码'}
 *  sendCode={store.onSendVCRequest}
 *  codeBtnClassName="appointmentModal-layer-10"
 *  btnClassName="send-btn-bg"
 *  validateCb = {() => {}
 *  />
 */
export default class SmsCodeInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countDown: null,
      validate: this.props.validate
    };
    this.loading = false;
    this.validateErrorCb = this.props.validateErrorCb || noop;
    this.onSmsButtonClick = this.onSmsButtonClick.bind(this);
  }

  @lockAsync()
  async onSmsButtonClick() {
    const { sendCode, email } = this.props;
    // console.log('phone:', this.props);
    const validate = this.validate(email);
    await this.setState({ loading: true });
    if (validate) {
      const sendCodeStatus = await sendCode({ email: email }).catch(err => {
        this.setState({ loading: false });
        console.error(err.msg);
      });
      await this.setState({ loading: false });
      if (sendCodeStatus && sendCodeStatus.$state === 0) {
        return;
      }
      if (sendCodeStatus) {
        sessionStorage.setItem('smsFirstTimes', '1');
        await this.countDown(60);
      }
    }
    await this.setState({ loading: false });
  }

  validate(email) {
    let isValid = false;
    if (!email) {
      message.error(getLocales('reserve.logic.need_email'));
      this.validateErrorCb(getLocales('reserve.logic.need_email'));
    } else if (!commonRegex.isEmail.test(email)) {
      message.error(getLocales('reserve.logic.email_format'));
      this.validateErrorCb(getLocales('reserve.logic.need_email'));
    } else {
      isValid = true;
    }

    return isValid;
  }

  async countDown(countDown) {
    const nextCountDown = countDown - 1;
    if (nextCountDown < 1) {
      this.setState({ countDown: null });
      return;
    }
    this.setState({ countDown: nextCountDown });
    await delay(1000);
    await this.countDown(nextCountDown);
  }

  renderButton() {
    let { buttonText = '获取验证码', btnClassName } = this.props;
    const { loading, countDown } = this.state;
    const { children } = this.props;
    let isNotFirstSend = sessionStorage.getItem('smsFirstTimes');
    // buttonText = countDown === null ? buttonText : `${countDown} 秒后重试`;
    buttonText =
      countDown === null
        ? !isNotFirstSend
          ? buttonText
          : getLocales('reserve.form.resend')
        : getLocales('reserve.logic.vcode_countdown', { countdown: countDown });
    if (loading) {
      return <div className={style.loading} />;
    }
    if (countDown) {
      return (
        <div className={cx(style.btn, btnClassName)}>
          {children}
          <div className={cx(style.sendButton, style.noCursor)}>{buttonText}</div>
        </div>
      );
    } else {
      return (
        <Link className={cx(style.btn, btnClassName)} onClick={this.onSmsButtonClick}>
          {children}
          <div className={cx(style.sendButton)}>{buttonText}</div>
        </Link>
      );
    }
  }

  render() {
    // noinspection JSUnusedLocalSymbols
    const { validateAndGetPhone, codeBtnClassName, ...restProps } = this.props;
    const { countDown } = this.state;
    return (
      <div className={style.smsCodeInput}>
        <div className={cx(style.smsButton, codeBtnClassName, countDown && style.btnDisable)}>{this.renderButton()}</div>
      </div>
    );
  }
}
